<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['emp.develop.appName']">
              <j-input :placeholder="this.language['basedata.pleaseEnter']+this.language['emp.develop.appName']"  v-model="queryParam.applicationName" allowClear></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['emp.develop.appCode']">
              <j-input :placeholder="language['basedata.pleaseEnter']+this.language['emp.develop.appCode']" v-model="queryParam.applicationCode" allowClear></j-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="this.language['system.user.name']">
              <a-input :placeholder="this.language['common.pleaseInput']+this.language['system.user.name']" v-model="queryParam.applyAccount" allowClear></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item :label="this.language['portal.personalName']">
              <a-input :placeholder="this.language['common.pleaseInput']+this.language['portal.personalName']" v-model="queryParam.applyName" allowClear></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
<!--      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('emp_dev_app_apply')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      &lt;!&ndash; 高级查询区域 &ndash;&gt;
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
<!--      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
<!--        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>-->
        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ language['common.noPicture'] }}</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" alt="" style="font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            :title="language['ad.image']"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>

        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
<!--          <a @click="handleEdit(record)">编辑</a>-->

          <a @click="handleAudit(record)" v-if="record.auditStatus == 'approving'" >{{ language['eletronicSigned.check'] }}</a>
          <a-divider type="vertical" v-if="record.auditStatus == 'approving'" />
          <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
<!--          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>

      </a-table>
    </div>

    <emp-dev-app-apply-modal ref="modalForm" @ok="modalFormOk"></emp-dev-app-apply-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpDevAppApplyModal from './modules/EmpDevAppApplyModal'
  import { filterDictText } from '@/components/dict/JDictSelectUtil'
  import { getDictItemsFromCache } from '@/api/api'

  export default {
    name: 'EmpDevAppApplyList',
    mixins:[JeecgListMixin, mixinDevice],
    props:{
      handleStatus:Number
    },
    components: {
      EmpDevAppApplyModal
    },
    data () {
      return {
        description: 'emp_dev_app_apply管理页面',
        // 表头
        /*columns: [

        ],*/
        url: {
          list: "/hhemp/devapply/empdevappapplys2",
          delete: "/hhemp/devapply/empdevappapply",
          deleteBatch: "/hhemp/devapply/empdevappapply/batch",
          exportXlsUrl: "/hhemp/devapply/export-xls",
          importExcelUrl: "/hhemp/devapply/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
        applicationCode:'platform',
        previewVisible: false,
        previewImage: '',
        queryParam: {
          handleStatus:this.handleStatus,
        },
        dictStatusList: [],
        dictJoinTypeList: [],
      }
    },
    created() {
      this.getSuperFieldList();
      this.dictStatusList = getDictItemsFromCache('emp_application_audit_status');
      this.dictJoinTypeList = getDictItemsFromCache('emp_application_jointype');
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['emp.develop.appName'],
              align:"center",
              dataIndex: 'applicationName'
            },
            {
              title:this.language['emp.develop.appCode'],
              align:"center",
              dataIndex: 'applicationCode'
            },
            /*{
              title:'应用图标',
              align:"center",
              dataIndex: 'applicationImgPath'
            },*/
            {
              title:this.language['emp.develop.appIcon'],
              width: 100,
              ellipsis:true,
              align:"center",
              dataIndex: 'applicationImgPath',
              scopedSlots: {customRender: "imgSlot"}
            },
            /*{
              title:'应用描述',
              align:"center",
              dataIndex: 'applicationDesc'
            },*/
            /*{
              title:'应用url（测试）',
              align:"center",
              dataIndex: 'applicationTestUrl'
            },
            {
              title:'应用url（正式）',
              align:"center",
              dataIndex: 'applicationProdUrl'
            },
            {
              title:'应用授权URL（测试）',
              align:"center",
              dataIndex: 'applicationAuthTestUrl'
            },
            {
              title:'应用授权URL（正式）',
              align:"center",
              dataIndex: 'applicationAuthProdUrl'
            },*/
            {
              title:this.language['system.user.name'],
              align:"center",
              width: 100,
              dataIndex: 'applyAccount'
            },
            {
              title:this.language['portal.personalName'],
              align:"center",
              width: 100,
              dataIndex: 'applyName'
            },
            {
              title:this.language['column.mailbox'],
              align:"center",
              dataIndex: 'applyEmail'
            },
            {
              title:this.language['column.Landline'],
              align:"center",
              width: 100,
              dataIndex: 'applyTelephone'
            },
            {
              title:this.language['emp.develop.applyNo'],
              align:"center",
              width: 100,
              dataIndex: 'applyNo'
            },
            {
              title:this.language['emp.develop.joinTypeTitle'],
              align:"center",
              width: 100,
              //dataIndex: 'joinType_dictText'
              dataIndex: 'joinType',
              customRender: (text) => {
                return filterDictText(this.dictJoinTypeList, text)
              },
            },
            {
              title:this.language['common.createTime'],
              width: 100,
              align:"center",
              dataIndex: 'createTime'
            },
            {
              title:this.language['emp.apptype.status'],
              align:"center",
              width: 100,
              //dataIndex: 'auditStatus_dictText'
              dataIndex: 'auditStatus',
              customRender: (text) => {
                return filterDictText(this.dictStatusList, text)
              },
            },
            /*{
              title:'审核时间',
              align:"center",
              dataIndex: 'auditTime',
              customRender:function (text) {
                return !text?"":(text.length>10?text.substr(0,10):text)
              }
            },
            {
              title:'审核人',
              align:"center",
              dataIndex: 'auditor'
            },
            {
              title:'审核意见',
              align:"center",
              dataIndex: 'auditRemark'
            },
            {
              title:'刪除标示',
              align:"center",
              dataIndex: 'delFlag'
            },
            {
              title:'备注',
              align:"center",
              dataIndex: 'remark'
            },*/
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            },
          ];
        }
      },
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'applicationName',text:'应用名称'})
        fieldList.push({type:'string',value:'applicationCode',text:'应用编码'})
        fieldList.push({type:'string',value:'applicationImgPath',text:'应用图标'})
        fieldList.push({type:'string',value:'applicationDesc',text:'应用描述'})
        fieldList.push({type:'string',value:'applicationTestUrl',text:'应用url（测试）'})
        fieldList.push({type:'string',value:'applicationProdUrl',text:'应用url（正式）'})
        fieldList.push({type:'string',value:'applicationAuthTestUrl',text:'应用授权URL（测试）'})
        fieldList.push({type:'string',value:'applicationAuthProdUrl',text:'应用授权URL（正式）'})
        fieldList.push({type:'string',value:'applyAccount',text:'申请人账号'})
        fieldList.push({type:'string',value:'applyName',text:'申请人姓名'})
        fieldList.push({type:'string',value:'applyEmail',text:'申请邮箱'})
        fieldList.push({type:'string',value:'applyTelephone',text:'分机'})
        fieldList.push({type:'string',value:'applyNo',text:'单据编号'})
        fieldList.push({type:'string',value:'joinType',text:'加入类别'})
        fieldList.push({type:'string',value:'auditStatus',text:'审核状态'})
        fieldList.push({type:'date',value:'auditTime',text:'审核时间'})
        fieldList.push({type:'string',value:'auditor',text:'审核人'})
        fieldList.push({type:'string',value:'auditRemark',text:'审核意见'})
        fieldList.push({type:'string',value:'delFlag',text:'刪除标示'})
        fieldList.push({type:'string',value:'remark',text:'备注'})
        this.superFieldList = fieldList
      },
      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
      handleAudit: function (record) {
        //record.flag = 'audit'
        this.$refs.modalForm.title = this.language['eletronicSigned.check'];
        this.$refs.modalForm.disableSubmit = false;
        this.$refs.modalForm.audit(record);
      },
      searchReset(){
        this.queryParam = {
          handleStatus:this.handleStatus,
        }
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
